module.exports = __webpack_public_path__ + "img/receipt-solid.83b05eb4.svg";